import { PropertyStatus } from '@repo/domain';

const statusLabels = {
  [PropertyStatus.Available]: 'Dostępne',
  [PropertyStatus.Reserved]: 'Zarezerwowane',
  [PropertyStatus.Sold]: 'Sprzedane',
  [PropertyStatus.ComingSoon]: 'Wkrótce'
};

export const getStatusLabel = (statusCode) => {
  return statusLabels[statusCode] || statusCode;
};

const statusIcons = {
  [PropertyStatus.Available]: '/assets/status-available.svg',
  [PropertyStatus.Reserved]: '/assets/status-reserved.svg',
  [PropertyStatus.Sold]: '/assets/status-sold.svg',
  [PropertyStatus.ComingSoon]: '/assets/status-coming-soon.svg'
};

export const getStatusIcon = (statusCode) => {
  return statusIcons[statusCode] || '/assets/status-default.svg';
};

export const resolveStatus = (statusCode) => {
  return {
    code: statusCode,
    label: getStatusLabel(statusCode),
    icon: getStatusIcon(statusCode)
  };
};
